(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(15);
	
	__webpack_require__(16);
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	__webpack_require__(20);
	
	__webpack_require__(21);
	
	__webpack_require__(22);
	
	__webpack_require__(23);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	/** fake functions to legacy rendered news */
	window.lzld = function () {
	    return false;
	};
	
	window.ads = {
	    printAds: function printAds(params) {
	        return false;
	    }
	};
	
	window.pintoValoracion = false;
	window.cargarValoracion = function () {
	    var botonValoracion = Voonto.$('#enviar_valoracion');
	    botonValoracion.hide(); // Se oculta el botón hasta que Gigya no se cargue correctamente
	    window.pintoValoracion = true;
	    return false;
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	/**  https://mths.be/endswith v0.2.0 by @mathias */
	if (!String.prototype.endsWith) {
	  (function () {
	    'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
	
	    var defineProperty = function () {
	      // IE 8 only supports `Object.defineProperty` on DOM elements
	      try {
	        var object = {};
	        var $defineProperty = Object.defineProperty;
	        var result = $defineProperty(object, object, object) && $defineProperty;
	      } catch (error) {}
	      return result;
	    }();
	    var toString = {}.toString;
	    var endsWith = function endsWith(search) {
	      if (this == null) {
	        throw TypeError();
	      }
	      var string = String(this);
	      if (search && toString.call(search) == '[object RegExp]') {
	        throw TypeError();
	      }
	      var stringLength = string.length;
	      var searchString = String(search);
	      var searchLength = searchString.length;
	      var pos = stringLength;
	      if (arguments.length > 1) {
	        var position = arguments[1];
	        if (position !== undefined) {
	          // `ToInteger`
	          pos = position ? Number(position) : 0;
	          if (pos != pos) {
	            // better `isNaN`
	            pos = 0;
	          }
	        }
	      }
	      var end = Math.min(Math.max(pos, 0), stringLength);
	      var start = end - searchLength;
	      if (start < 0) {
	        return false;
	      }
	      var index = -1;
	      while (++index < searchLength) {
	        if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
	          return false;
	        }
	      }
	      return true;
	    };
	    if (defineProperty) {
	      defineProperty(String.prototype, 'endsWith', {
	        'value': endsWith,
	        'configurable': true,
	        'writable': true
	      });
	    } else {
	      String.prototype.endsWith = endsWith;
	    }
	  })();
	}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof window.fbq !== 'function' && vocento.tracking.config.facebookId !== 'undefined' && vocento.tracking.comscore.voc_tc === 'noticia' && vocento.tracking.config.facebookId !== undefined) {
	  !function (f, b, e, v, n, t, s) {
	    if (f.fbq) return;
	    n = f.fbq = function () {
	      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
	    };
	    if (!f._fbq) f._fbq = n;
	    n.push = n;
	    n.loaded = !0;
	    n.version = '2.0';
	    n.queue = [];
	    t = b.createElement(e);
	    t.async = !0;
	    t.src = v;
	    s = b.getElementsByTagName(e)[0];
	    s.parentNode.insertBefore(t, s);
	  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
	  window.fevents = true;
	  fbq('init', vocento.tracking.config.facebookId);
	  fbq('track', "PageView");
	}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	window.Krux || ((window.Krux = function () {
	  Krux.q.push(arguments);
	}).q = []);
	(function () {
	  var k = document.createElement('script');
	  k.type = 'text/javascript';
	  k.async = true;
	  var m,
	      src = (m = location.href.match(/\bkxsrc=([^&]+)/)) && decodeURIComponent(m[1]);
	  k.src = /^https?:\/\/([^\/]+\.)?krxd\.net(:\d{1,5})?\//i.test(src) ? src : src === "disable" ? "" : (location.protocol === "https:" ? "https:" : "http:") + "//cdn.krxd.net/controltag?confid=" + vocento.tracking.config.kruxId;
	  var s = document.getElementsByTagName('script')[0];
	  s.parentNode.insertBefore(k, s);
	})();
	
	window.Krux || ((window.Krux = function () {
	  Krux.q.push(arguments);
	}).q = []);
	(function () {
	  var Krux = self.Krux.vocento = self.Krux.vocento || {};
	
	  function retrieve(n) {
	    var m,
	        k = 'kxvocento_' + n;
	    if (window.localStorage) {
	      return window.localStorage[k] || "";
	    } else if (navigator.cookieEnabled) {
	      m = document.cookie.match(k + '=([^;]*)');
	      return m && unescape(m[1]) || "";
	    } else {
	      return '';
	    }
	  }
	
	  Krux.user = retrieve('user');
	  Krux.segments = retrieve('segs') ? retrieve('segs').split(',') : [];
	  var dfpp = [];
	  if (Krux.user) {
	    dfpp.push('khost=' + encodeURIComponent(location.hostname));
	    dfpp.push('kuid=' + Krux.user);
	  }
	  for (var i = 0; i < Krux.segments.length; i++) {
	    dfpp.push('ksg=' + Krux.segments[i]);
	  }
	  Krux.dfppKeyValues = dfpp.length ? dfpp.join(';') + ';' : '';
	})();
	window.vocento.tracking.comscore.voc_krux = Krux.vocento.user;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var cs = vocento.tracking.comscore;
	
	/**
	 * @param t
	 * @return {string}
	 */
	function normat(t) {
	  var str = t;
	  var lDcs = [{ b: "a", l: /[\u00e1\u00e0\u00e2\u00e3\u00e4]/g }, { b: "e", l: /[\u00e9\u00e8\u00ea\u00eb]/g }, {
	    b: "i",
	    l: /[\u00ed\u00ec\u00ee\u00ef]/g
	  }, { b: "o", l: /[\u00f3\u00f2\u00f4\u00f5\u00f6]/g }, { b: "u", l: /[\u00fa\u00f9\u00fb\u00fc]/g }, {
	    b: "n",
	    l: /[\u00f1]/g
	  }, { b: "c", l: /[\u00e7]/g }, { b: "-", l: /[\. \-]+/g }, { b: "_", l: /[|/_]+/g }, { b: "", l: /[^a-z_0-9-]+/g }, {
	    b: "-",
	    l: /[\-]+/g
	  }, { b: "_", l: /[\-]*_[\-]*/g }];
	  str = str.toLowerCase();
	  for (var i = 0; i < lDcs.length; i++) {
	    str = str.replace(lDcs[i].l, lDcs[i].b);
	  }
	  return str;
	}
	
	/**
	 * Return string cookie content
	 * @param name
	 * @returns {string}
	 */
	function getCookieContent(name) {
	  var value = "; " + document.cookie;
	  var parts = value.split("; " + name + "=");
	  if (parts.length === 2) return parts.pop().split(";").shift();
	}
	
	/**
	 * Get
	 * @param key
	 * @returns {string}
	 */
	function getUserData(key) {
	  var value = '';
	  var cookieContent = getCookieContent('voc_uid');
	  if (typeof cookieContent !== 'undefined') {
	    try {
	      var vocUid = JSON.parse(decodeURIComponent(cookieContent));
	      if ((typeof vocUid === "undefined" ? "undefined" : _typeof(vocUid)) === 'object' && vocUid.hasOwnProperty(key)) {
	        value = vocUid[key];
	      }
	    } catch (err) {}
	  }
	  return value;
	}
	
	/**  voc_user */
	cs.voc_tusr = window.__VOONTO__.getUserType();
	cs.voc_usrid = getUserData('uid').replace(/=/g, ".");
	cs.voc_usrcp = getUserData('zip');
	cs.voc_usrgen = getUserData('gender');
	cs.voc_usrag = getUserData('age');
	
	/** voc_s4 normat */
	cs.voc_s4 = normat(cs.voc_s4);
	
	/** voc_ho */
	document.referrer === '//' + document.domain + '/' || document.referrer === '//' + document.domain + '/index.asp' || document.referrer === '//' + document.domain + '/index.php' || document.referrer === '//' + document.domain + '/index.html' ? cs.voc_ho = 1 : cs.voc_ho = 0;
	
	/** voc_name */
	cs.voc_name = (cs.voc_se !== '' ? cs.voc_se + '.' : '') + (cs.voc_s1 !== '' ? cs.voc_s1 + '.' : '') + (cs.voc_s2 !== '' ? cs.voc_s2 + '.' : '') + (cs.voc_s3 !== '' ? cs.voc_s3 + '.' : '') + (cs.voc_s4 !== '' ? cs.voc_s4 + '.' : '') + cs.voc_tn;
	
	/** segments */
	if (typeof cs.voc_se === 'undefined') {
	  var segments = window.location.href.split("/");
	  try {
	    if (3 in segments) {
	      cs.voc_se = segments[3];
	      if (segments[3].indexOf(".htm") > -1) {
	        cs.voc_se = '';
	      }
	      if (segments[3].indexOf(".php") > -1) {
	        cs.voc_se = '';
	      }
	      if (segments[3].indexOf(".asp") > -1) {
	        cs.voc_se = '';
	      }
	      if (segments[3].indexOf(".php") > -1) {
	        cs.voc_se = '';
	      }
	    }
	  } catch (err) {}
	
	  try {
	    if (4 in segments) {
	      cs.voc_s1 = segments[4];
	      if (segments[4].indexOf(".htm") > -1) {
	        cs.voc_s1 = '';
	      }
	      if (segments[4].indexOf(".php") > -1) {
	        cs.voc_s1 = '';
	      }
	      if (segments[4].indexOf(".asp") > -1) {
	        cs.voc_s1 = '';
	      }
	      if (segments[4].indexOf(".php") > -1) {
	        cs.voc_s1 = '';
	      }
	    }
	  } catch (err) {}
	
	  try {
	    if (5 in segments) {
	      cs.voc_s2 = segments[5];
	      if (segments[5].indexOf(".htm") > -1) {
	        cs.voc_s2 = '';
	      }
	      if (segments[5].indexOf(".php") > -1) {
	        cs.voc_s2 = '';
	      }
	      if (segments[5].indexOf(".asp") > -1) {
	        cs.voc_s2 = '';
	      }
	      if (segments[5].indexOf(".php") > -1) {
	        cs.voc_s2 = '';
	      }
	    }
	  } catch (err) {}
	
	  try {
	    if (6 in segments) {
	      cs.voc_s3 = segments[6];
	      if (segments[6].indexOf(".htm") > -1) {
	        cs.voc_s3 = '';
	      }
	      if (segments[6].indexOf(".php") > -1) {
	        cs.voc_s3 = '';
	      }
	      if (segments[6].indexOf(".asp") > -1) {
	        cs.voc_s3 = '';
	      }
	      if (segments[6].indexOf(".php") > -1) {
	        cs.voc_s3 = '';
	      }
	    }
	  } catch (err) {}
	
	  cs.voc_pr = 1;
	  cs.voc_pu = '';
	}
	
	/** adblock Check */
	if (typeof checkAdBlock === 'undefined') {
	  cs.voc_adb = 1;
	}
	/** Krux check */
	if (typeof Krux === 'undefined') {
	  cs.voc_krux = "0";
	}
	/** voc_adp */
	if (getCookieContent("voc_mobile") === "activo") {
	  cs.voc_adp = "2";
	}
	
	/** replace incorrect url's */
	var lineaurl = "";
	if (document.location.href.indexOf("/20") > -1) {
	  lineaurl = window.location.href;
	  lineaurl = lineaurl.replace("www-origin", "www");
	  lineaurl = lineaurl.replace("www-new.abc.es", "www.abc.es");
	  lineaurl = lineaurl.replace("sevilla-new.abc.es", "sevilla.abc.es");
	  lineaurl = lineaurl.replace("sevilla-origin.abc.es", "sevilla.abc.es");
	  lineaurl = lineaurl.replace("www.abcdesevilla.es", "sevilla.abc.es");
	}
	
	/** Export to window */
	/** remove tgm website after remove datalayer gtm
	  window.tgm_website = vocento.tracking.dataLayer.tgm_website;
	  window.dataLayer = vocento.tracking.dataLayer;
	*/
	
	/** others export */
	window.lineaurl = lineaurl;
	
	/** comscore export */
	for (var key in cs) {
	  if (cs.hasOwnProperty(key)) {
	    window[key] = cs[key];
	  }
	}
	
	/** root export */
	for (var _key in vocento.tracking.root) {
	  if (vocento.tracking.root.hasOwnProperty(_key)) {
	    window[_key] = vocento.tracking.root[_key];
	  }
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	if (vocento.tracking.root.httpStatus !== '404') {
	    (function (w, d, s, l, i) {
	        w[l] = w[l] || [];
	        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
	        var f = d.getElementsByTagName(s)[0],
	            j = d.createElement(s),
	            dl = l != 'dataLayer' ? '&l=' + l : '';
	        j.async = true;
	        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
	        f.parentNode.insertBefore(j, f);
	    })(window, document, 'script', 'dataLayer', vocento.tracking.config.gtmKey);
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (e) {
	  function o(n) {
	    if (t[n]) return t[n].exports;var d = t[n] = { exports: {}, id: n, loaded: !1 };return e[n].call(d.exports, d, d.exports, o), d.loaded = !0, d.exports;
	  }var t = {};return o.m = e, o.c = t, o.p = "", o(0);
	}([function (e, o, t) {
	  "use strict";
	  function n(e) {
	    return e && e.__esModule ? e : { default: e };
	  }var d = t(1),
	      i = n(d);window.DigitalContext = i.default;
	}, function (e, o, t) {
	  "use strict";
	  function n(e) {
	    return e && e.__esModule ? e : { default: e };
	  }Object.defineProperty(o, "__esModule", { value: !0 });var d = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
	    return typeof e === "undefined" ? "undefined" : _typeof(e);
	  } : function (e) {
	    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
	  },
	      i = t(2),
	      c = n(i),
	      r = !1,
	      a = c.default.version,
	      u = { version: a, analytics: {}, browser: {}, content: {}, ecommerce: {}, user: {} },
	      f = function f(e) {
	    try {
	      var o = document.querySelector("meta[name='" + e + "']").getAttribute("content");return o;
	    } catch (e) {}return "";
	  },
	      s = function s() {
	    var e = "voc_usr_nl",
	        o = window.location.hash,
	        t = o.match("[#|?|&]" + e + "=([^#&?]*)[#?&$]*");return t && t[1] ? t[1] : "undefined" != typeof voc_usrid ? voc_usrid || "" : "";
	  },
	      p = function p() {
	    u.analytics = { comscore: { advertisement_blocker: "undefined" != typeof voc_adb ? voc_adb || "" : "", content: { author: "undefined" != typeof voc_au ? voc_au || "" : "", language: "undefined" != typeof voc_idi ? voc_idi || "" : "", modification_date: "undefined" != typeof voc_fem ? voc_fem || "" : "", publication_date: "undefined" != typeof voc_fep ? voc_fep || "" : "", title: "undefined" != typeof voc_tn ? voc_tn || "" : "", type: "undefined" != typeof voc_tc ? voc_tc || "" : "" }, cover_source: "undefined" != typeof voc_ho ? voc_ho || "" : "", domain_type: "undefined" != typeof voc_pr ? voc_pr || "" : "", edition: "undefined" != typeof voc_ed ? voc_ed || "" : "", information_source: "undefined" != typeof voc_or ? voc_or || "" : "", krux: { tagged: "undefined" != typeof voc_krux ? voc_krux || "" : "" }, mobile_cookie: "undefined" != typeof voc_adp ? voc_adp || "" : "", platform_content: "undefined" != typeof voc_pl ? voc_pl || "" : "", paywall: { authorization: "undefined" != typeof voc_pw_result ? voc_pw_result || "" : "", cookie: "undefined" != typeof voc_pw_cookie ? voc_pw_cookie || "" : "", count: "undefined" != typeof voc_pw_count ? voc_pw_count || "" : "", counter_max: "undefined" != typeof voc_pw_max ? voc_pw_max || "" : "", meter: "undefined" != typeof voc_pw_meter ? voc_pw_meter || "" : "", uid: "undefined" != typeof voc_pw_pid ? voc_pw_pid || "" : "" }, publish_system: "undefined" != typeof voc_pu ? voc_pu || "" : "", section: { level_1: "undefined" != typeof voc_s1 ? voc_s1 || "" : "", level_2: "undefined" != typeof voc_s2 ? voc_s2 || "" : "", level_3: "undefined" != typeof voc_s3 ? voc_s3 || "" : "", level_4: "undefined" != typeof voc_s4 ? voc_s4 || "" : "", name: "undefined" != typeof voc_se ? voc_se || "" : "" }, site: { id: "undefined" != typeof ns_site ? ns_site || "" : "", name: "undefined" != typeof voc_site ? voc_site || "" : "" }, topic_grouping: "undefined" != typeof voc_ate ? voc_ate || "" : "", topics: "undefined" != typeof voc_top ? voc_top || "" : "", user: { access: "undefined" != typeof voc_usrser ? voc_usrser || "" : "", age: "undefined" != typeof voc_usrag ? voc_usrag || "" : "", id: s(), gender: "undefined" != typeof voc_usrgen ? voc_usrgen || "" : "", navigation_track: "undefined" != typeof voc_usrsvs ? voc_usrsvs || "" : "", postal_code: "undefined" != typeof voc_usrcp ? voc_usrcp || "" : "", type: "undefined" != typeof voc_tusr ? voc_tusr || "" : "" } } };
	  },
	      _ = function _() {
	    u.browser = { domain: document.domain, url: document.URL };
	  },
	      v = function v() {
	    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
	        o = { section: "", site: "", subsection: "", type: "", metadata: { author: "", description: "", keywords: "", title: "" } };"undefined" != typeof e.site && (o.site = e.site), "undefined" != typeof e.section && (o.section = e.section), "undefined" != typeof e.subsection && (o.subsection = e.subsection), "undefined" != typeof e.type && (o.type = e.type);var t = "object" === d(e.metadata);t && "undefined" != typeof e.metadata.author ? o.metadata.author = "" + e.metadata.author : o.metadata.author = f("author"), t && "undefined" != typeof e.metadata.description ? o.metadata.description = "" + e.metadata.description : o.metadata.description = f("description"), t && "undefined" != typeof e.metadata.keywords ? o.metadata.keywords = "" + e.metadata.keywords : (o.metadata.keywords = f("news_keywords"), "" === o.metadata.keywords && (o.metadata.keywords = f("keywords"))), t && "undefined" != typeof e.metadata.title ? o.metadata.title = "" + e.metadata.title : o.metadata.title = document.title, u.content = o;
	  },
	      y = function y() {
	    u.ecommerce = { client: { id: "undefined" != typeof ns_client_id ? ns_client_id || "" : "" }, order: { id: "undefined" != typeof ns_order_id ? ns_order_id || "" : "", product: { id: "undefined" != typeof ns_pro_id ? ns_pro_id || "" : "", name: "undefined" != typeof ns_brand ? ns_brand || "" : "", category: "undefined" != typeof ns_prod_grp ? ns_prod_grp || "" : "", price: "undefined" != typeof ns_prod_price ? ns_prod_price || "" : "" }, quantity: "undefined" != typeof ns_qty ? ns_qty || "" : "" }, shop: { name: "undefined" != typeof ns_shop ? ns_shop || "" : "" } };
	  },
	      l = function l() {
	    u.user = {};
	  },
	      m = function m() {
	    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};p(), _(), v(e), y(), l(), r = !0;
	  };o.default = { isBooted: function isBooted() {
	      return r;
	    }, getVersion: function getVersion() {
	      return a;
	    }, getContext: function getContext() {
	      return !1 === r && m(), u;
	    }, init: m };
	}, function (e, o) {
	  e.exports = { name: "digital-context", version: "2.1.1", description: "Vocento Digital Context", main: "src/index.js", scripts: { test: 'echo "Error: no test specified" && exit 1' }, author: "Ariel Ferrandini <aferrandini@vocento.com>", license: "propietary", devDependencies: { "babel-core": "^6.17.0", "babel-loader": "^6.2.5", "babel-polyfill": "^6.16.0", "babel-preset-es2015": "^6.16.0", chai: "^3.5.0", "json-loader": "^0.5.4", mocha: "^3.1.0", "mocha-loader": "^1.0.0", webpack: "^1.13.2" } };
	}]);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	var Kruxinit = {
	  'site': window.vocento.tracking.comscore.ns_site,
	  'section': window.vocento.tracking.comscore.voc_se,
	  'subsection': window.vocento.tracking.comscore.voc_s1,
	  'type': window.vocento.tracking.comscore.voc_tc
	};
	
	DigitalContext.init(Kruxinit);
	window.context = DigitalContext.getContext();

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	/** Only abc media */
	if (vocento.config.nibara.media === 'abc') {
	  (function (d, s, id, token) {
	    var js = void 0,
	        djs = d.getElementsByTagName(s)[0];
	    if (d.getElementById(id)) {
	      return;
	    }
	    js = d.createElement("script");
	    js.id = id;
	    js.async = 1;
	    js.src = "//rrss.abc.es/pixel/js/" + token;
	    djs.parentNode.insertBefore(js, djs);
	  })(document, 'script', 'dogtrack-app', "ABCES");
	}

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// trackingHead.js